// Lig Ayarlamaları sayfasının yetkileri. Ayrı dosyada durur: menü ve rota
// tanımı, sayfanın kendisini (lazy) ana pakete çekmeden bunu kullanır.
export const LEAGUE_SETTINGS_SECTION_PERMISSIONS = Object.freeze({
  "kural-kitapciklari": ["rule_books.create", "rule_books.update"],
  // Sezonun grupları ve eleme turları (eski "Gruplar" sayfası).
  "lig-statusu": ["groups.view", "groups.create", "groups.update", "groups.delete"],
});

/** Sayfaya erişim: bölümlerden herhangi birinin yetkisi yeterli. */
export const LEAGUE_SETTINGS_PERMISSIONS = [
  ...new Set(Object.values(LEAGUE_SETTINGS_SECTION_PERMISSIONS).flat()),
];
